var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIdCardBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8ow51s6opa",
    d: "M12 2.4c-.663 0-1.2.537-1.2 1.2v1.2c0 .663.537 1.2 1.2 1.2.663 0 1.2-.537 1.2-1.2V3.6c0-.663-.537-1.2-1.2-1.2zM4.8 4.8h3.6c0 1.988 1.612 3.6 3.6 3.6s3.6-1.612 3.6-3.6h3.6c1.325 0 2.4 1.075 2.4 2.4V18c0 1.325-1.075 2.4-2.4 2.4H4.8c-1.325 0-2.4-1.075-2.4-2.4V7.2c0-1.325 1.075-2.4 2.4-2.4zm3 8.4c.994 0 1.8-.806 1.8-1.8s-.806-1.8-1.8-1.8-1.8.806-1.8 1.8.806 1.8 1.8 1.8zm2.94 4.8c.242-1.192-.26-2.412-1.27-3.09-1.01-.676-2.33-.676-3.34 0-1.01.678-1.512 1.898-1.27 3.09h5.88zm3.66-7.2c-.663 0-1.2.537-1.2 1.2 0 .663.537 1.2 1.2 1.2H18c.663 0 1.2-.537 1.2-1.2 0-.663-.537-1.2-1.2-1.2h-3.6zm-1.2 4.8c0-.663.537-1.2 1.2-1.2h2.4c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-2.4c-.663 0-1.2-.537-1.2-1.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#37c0ca",
    xlinkHref: "#8ow51s6opa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCardBlue);
export default __webpack_public_path__ + "static/media/icon-id-card-blue.819cd3480a2a394f362f051091780e9b.svg";
export { ForwardRef as ReactComponent };